import {useState} from "react";
import {Stack} from "@mantine/core";
import {TopSplashInput} from "../chat/components/TopSplashInput";
import {useSplashSubmit} from "../chat/hooks/useSplashSubmit";
import classes from "./DashboardView.module.css";

type DashboardSearchSectionProps = {
    compact?: boolean;
};

export function DashboardSearchSection({compact = false}: DashboardSearchSectionProps) {
    const [value, setValue] = useState("");
    const handleSendMessage = useSplashSubmit();

    return (
        <Stack className={classes.searchSection} gap={0}>
            <TopSplashInput
                value={value}
                onSendMessage={handleSendMessage}
                onValueChange={setValue}
                showKaiBranding
                compact={compact}
            />
        </Stack>
    );
}
